import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { User } from '@generated/models';
import { AdelaideService } from '@web/core/adelaide/adelaide.service';
import { Tenant } from '@web/core/services/tenants/tenant.abstract';
import { environment } from '@web/env/environment';
import { SearchModalComponent, SearchModalOptions } from '@web/shared/components/search/search-modal.component';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';

@Component({
  selector: 'app-main-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarModule, IconFieldModule, InputIconModule, InputTextModule, ButtonModule, RouterLink, MenuModule],
  providers: [DialogService],
  template: ` @let _user = user();

    <div class="flex w-full justify-between items-center">
      <div [routerLink]="'./dashboard'" class="cursor-pointer">
        <img [src]="tenant().logo" class="h-11 object-contain" alt="logo" />
      </div>
      <div class="w-90">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input type="text" pInputText placeholder="Search" i18n-placeholder class="w-full" (click)="openSearch()" />
        </p-iconfield>
      </div>
      <div class="min-w-40 flex justify-end">
        <p-menu #menu [model]="userMenuItems" [popup]="true" appendTo="body" />
        <p-button size="small" variant="text" [rounded]="true" (click)="menu.toggle($event)">
          <span> {{ _user?.displayName }} </span>
          <p-avatar icon="pi pi-user" class="mr-2" shape="circle" />
        </p-button>
        @if (adelaideEnabled) {
          <p-button
            outlined="true"
            [style]="{ '--p-button-padding-y': 0, '--p-button-padding-x': 0 }"
            (click)="toggleAdelaide()"
          >
            <div
              class="size-10 bg-cover"
              [style]="{
                backgroundImage: 'url(/img/adelaide.jpg)',
              }"
            ></div>
          </p-button>
        }
      </div>
    </div>`,
  styles: ``,
})
export class MainHeaderComponent {
  readonly user = input.required<User | null>();
  readonly tenant = input.required<Tenant>();
  private readonly adelaideService = inject(AdelaideService);

  readonly adelaideEnabled = environment.adelaide;

  private readonly dialog = inject(DialogService);
  openSearch() {
    this.dialog.open(SearchModalComponent, SearchModalOptions);
  }

  toggleAdelaide() {
    if (this.adelaideEnabled) {
      this.adelaideService.toggle();
    }
  }

  readonly userMenuItems: MenuItem[] = [
    {
      label: $localize`My Profile`,
      routerLink: ['/', 'profile'],
      icon: 'pi pi-user',
      styleClass: 'leading-none',
    },
    {
      label: $localize`Logout`,
      routerLink: ['/', 'auth', 'logout'],
      icon: 'pi pi-sign-out',
      styleClass: 'leading-none',
    },
  ];
}
